export default __webpack_public_path__ + "static/media/Dedicated-consultant-will-be-assigned.6ed9a112.png";